import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { RegraAutomacao } from '@pgcustom/shared-types';

/**
 * Adapter do módulo Automações no frontend — único ponto que conhece o
 * formato de `/api/v1/automacoes/*`
 * (`apps/api/src/modules/automacoes/automacoes.routes.ts`, Sprint 13).
 */
export class AutomacoesApi {
  constructor(private readonly api: ApiClient) {}

  async listarRegras(): Promise<Resultado<RegraAutomacao[]>> {
    try {
      const resposta = await this.api.get<{ regras: RegraAutomacao[] }>('/automacoes/regras');
      if (resposta.regras.length === 0) return { status: 'vazio' };
      return { status: 'ok', dado: resposta.regras };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return { status: 'erro', mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar regras de automação' };
    }
  }

  async atualizarAtiva(chave: string, ativa: boolean): Promise<RegraAutomacao> {
    const resposta = await this.api.patch<{ regra: RegraAutomacao }>(`/automacoes/regras/${chave}`, { ativa });
    return resposta.regra;
  }
}
